const constants = {
    VIEWS: {
        CHAT_LIST: "chatList",
        CHAT_HANLDER: "chatHandler",
        CHAT_INFO: "chatInfo",
    },
    FILTERS: {
        ME: "ME",
        UNASSIGNED: "UNASSIGNED",
        CLOSED: "CLOSED",
        ALL: "ALL",
        ACTIVE: "ACTIVE",
        ENDED: "ENDED",
        AGENTS: "AGENTS",
        UPDATED_ON: "UPDATED_ON",
        LAST_END_USER_ACTIVITY: "LAST_END_USER_ACTIVITY",
        AI_AGENTS: "AI_AGENTS",
        WAITING_ANSWER: "WAITING_ANSWER",
        INIT_BY_AGENT: "INIT_BY_AGENT",
        ASC: "ASC",
        DESC: "DESC",
        HUMAN_AGENTS: "HUMAN_AGENTS",
        DATE_FIELD_FILTERS: {
            CREATED_ON: "CREATED_ON",
            UPDATED_ON: "UPDATED_ON",
            LAST_END_USER_ACTIVITY: "LAST_END_USER_ACTIVITY",
            START_WAITING_ON: "START_WAITING_ON",
            CLOSED_ON: "CLOSED_ON",
            ASSIGNED_TO_HUMAN_AGENT_ON: "ASSIGNED_TO_HUMAN_AGENT_ON"
        },
    },
    CHATS: {
        USER_TYPE: {
            AGENT: 0,
            USER: 1,
        },
        CONTENT_TYPE: {
            LINK: "LINK",
            DOCUMENT: "DOCUMENT",
            IMAGE: "IMAGE",
            VIDEO: "VIDEO",
            NOTE: "NOTE",
            PLAIN: "PLAIN",
            TEXT: "TEXT",
            AUDIO: "AUDIO",
            SERVER_MESSAGE: "SERVER_MESSAGE",
        },
        OPTIONS: {
            ALL: "ALL",
            ASSIGN: "ASSIGN",
            UNASSIGN: "UNASSIGN",
            CLOSE: "CLOSE",
            UNASSIGNED: "UNASSIGNED",
            ME: "ME",
            DERIVATE: "DERIVATE",
            CHANGE_GROUP: "CHANGE_GROUP",
            RELOAD: "RELOAD",
            MARK_READ: "MARK_READ",
            MARK_UNREAD: "MARK_UNREAD",
        },
        ERRORS: {
            GROUP_NOT_ASSIGNED: "CHAT_GROUPS_CAN_NOT_BE_UPDATED_BECAUSE_CHAT_IS_ASSIGNED",
            GROUP_NOT_BELONGS:
                "CHAT_GROUPS_CAN_NOT_BE_UPDATED_BECAUSE_USER_NOT_BELONGS_TO_DERIVATION_GROUP",
        },
        MESSAGE_FROM: {
            DEFAULT_ASSISTANT: "DEFAULT_ASSISTANT",
            ASSISTANT: "ASSISTANT",
            CHAT_BOT: "CHAT_BOT",
            END_USER: "END_USER",
            SERVER: "SERVER",
            ASSISTANT_NOTE: "ASSISTANT_NOTE",
        },
        STATES: {
            EMPTY: "EMPTY",
            LOADING: "LOADING",
            OPEN: "OPEN",
            ERROR: "ERROR",
            ASSIGNING: "ASSIGNING",
        },
    },
    CHANNELS: {
        OPTIWE_CHAT: "OPTIWE_CHAT",
        WHATSAPP: "WHATSAPP",
        INSTAGRAM: "INSTAGRAM",
        FACEBOOK: "FACEBOOK",
        SMS: "SMS",
        FACEBOOK_COMMENT: "FACEBOOK_COMMENT",
    },
    SERVER_MESSAGES: {
        OPENED: "OPENED",
        CLOSED_BY_USER: "CLOSED_BY_USER",
        CLOSED_BY_SYSTEM: "CLOSED_BY_SYSTEM",
        OWNER_CHANGE_FROM_BOT_TO_AGENT: "OWNER_CHANGE_FROM_BOT_TO_AGENT",
        OWNER_CHANGE_FROM_BOT_TO_NONE: "OWNER_CHANGE_FROM_BOT_TO_NONE",
        OWNER_CHANGE_FROM_NONE_TO_BOT: "OWNER_CHANGE_FROM_NONE_TO_BOT",
        OWNER_CHANGE_FROM_NONE_TO_AGENT: "OWNER_CHANGE_FROM_NONE_TO_AGENT",
        OWNER_CHANGE_FROM_AGENT_TO_ANOTHER_AGENT: "OWNER_CHANGE_FROM_AGENT_TO_ANOTHER_AGENT",
        OWNER_CHANGE_FROM_AGENT_TO_NONE: "OWNER_CHANGE_FROM_AGENT_TO_NONE",
        OWNER_CHANGE_FROM_NONE_TO_NONE: "OWNER_CHANGE_FROM_NONE_TO_NONE",
        GROUP_ADDED: "GROUP_ADDED",
        GROUP_REMOVED: "GROUP_REMOVED",
        TAG_ADDED: "TAG_ADDED",
        TAG_REMOVED: "TAG_REMOVED",
    },
    LOCAL_STORAGE_KEYS: {
        PUSH_NOTIFICATIONS: "optiwePushNotifications",
        INSTALL_PROMPT: "optiweInstallAppPrompt",
        FCM_NOTIFICATIONS: "OptiweFCMNotifications",
    },
    SOCKET_STATUS: {
        CONNECTED: "CONNECTED",
        RECONNECTING: "RECONNECTING",
        DISCONNECTED: "DISCONNECTED",
        ERROR: "ERROR",
    },
    DEVICE_TYPE: {
        IOS: "IOS",
        ANDROID: "ANDROID",
        WEB: "WEB",
    },
};
export default constants;
